<template>
  <section class="new-filtro">
    <FiltrosDefault v-if="filtros.length > 0" :filtros="filtros" :path="dataProperties.path" />
    <BotaoAdicionarFiltro
      @renderizarFiltros="renderizarFiltros"
      :filtros="filtros"
      :campos="dataProperties.campos"
    />
    <LimparFiltro @limparFiltro="limparFiltro" />
  </section>
</template>
<script>
import BotaoAdicionarFiltro from './components/BotaoAdicionarFiltro.vue';
import LimparFiltro from './components/LimparFiltro.vue';
import FiltrosDefault from './filtros/FiltrosDefault.vue';
export default {
  props:{
    page:{
      type: String,
      default: () => ("{}")
    }
  },
  components: {
    BotaoAdicionarFiltro,
    LimparFiltro,
    FiltrosDefault
  },
  data() {
    return {
      dataProperties: JSON.parse(this.page)
    }
  },
  computed: {
    filtros() {
      return this.$store.state.filtros;
    }
  },
  methods: {
    renderFiltrosDefault() {
      const filtros = this.dataProperties.campos.filter(campo => campo.default);
      filtros.forEach(filtro => {
        this.$store.commit('addFiltro', filtro);
      });
      return filtros;
    },
    salvarFiltrosNoDb() {
      const filtrosParaSalvar = this.filtros.filter(filtro => !filtro.default);
      this.$filtroDb.salvarFiltros(this.dataProperties.path, filtrosParaSalvar)
        .catch(error => exibe_erro('Erro ao salvar preferencias de filtros:'));
    },
    carregarFiltrosDoDb() {
      this.$filtroDb.recuperarFiltros(this.dataProperties.path)
        .then(filtrosSalvos => {
          const filtrosDefault = this.renderFiltrosDefault();
          const filtrosCombinados = [...filtrosDefault, ...filtrosSalvos];
          
          const filtrosUnicos = filtrosCombinados.filter((filtro, index, self) => 
            index === self.findIndex(f => f.filtro === filtro.filtro)
          );
          
          this.renderizarFiltros(filtrosUnicos);
        })
        .catch(error => exibe_erro('Erro ao carregar preferencias de filtros:'));
    },
    limparFiltro() {
      this.$store.commit('limparFiltros');
      this.$limparFiltrosDaURL(this.dataProperties.path);
      this.$filtroDb.removerFiltros(this.dataProperties.path)
        .catch(error => exibe_erro('Erro ao remover preferencias de filtros:'));
      
      const filtrosDefault = this.renderFiltrosDefault();
      this.renderizarFiltros(filtrosDefault);
    },
    renderizarFiltros(filtros) {
      if (!Array.isArray(filtros)) {
        console.warn('renderizarFiltros: parâmetro deve ser um array');
        return;
      }

      const filtrosDefault = this.renderFiltrosDefault();
      const filtrosSemDefault = filtros.filter(filtro => !filtro.default);
      const filtrosCombinados = [...filtrosDefault, ...filtrosSemDefault];
      
      const filtrosUnicos = filtrosCombinados.filter((filtro, index, self) => 
        index === self.findIndex(f => f.filtro === filtro.filtro)
      );

      this.removeFiltrosDeselecionados(filtrosUnicos);
      
      filtrosUnicos.forEach(filtro => {
        this.$store.commit('addFiltro', filtro);
        if(filtro.advanced && filtro.advancedSetting) {
          const { advancedSetting, filtro: campoFiltro } = filtro;
          this.$store.commit('addAdvancedSetting', {filtro: campoFiltro, value: advancedSetting});
        }
      });
      this.$store.commit('setFiltros', filtrosUnicos);
      this.salvarFiltrosNoDb();
    },
    buscaFiltros() {
      const { campos } = this.dataProperties.filtros;
      const REGEX_FILTRO_PERIODO = /_ini$|_fim$/;

      Object.keys(campos).forEach(key => {
        if (['filtro_aplicado', '_', 'page'].includes(key)) return;

        let valor = Array.isArray(campos[key]) ? campos[key].join(',') : campos[key];
        
        if ((key.endsWith('_ini') || key.endsWith('_fim')) && valor) {
          valor = this.converterDataParaFormatoCorreto(valor);
        }

        this.$aplicaFiltroEmURL(key, valor, this.dataProperties.path);

        let filtroCorrespondente = this.dataProperties.campos.find(campo => campo.filtro === key);
        
        if (!filtroCorrespondente && (key.endsWith('_ini') || key.endsWith('_fim'))) {
          const filtroBase = key.replace(REGEX_FILTRO_PERIODO, '');
          filtroCorrespondente = this.dataProperties.campos.find(campo => 
            campo.filtro === filtroBase && campo.component === 'date/DataEmissao'
          );
        }
        
        if (filtroCorrespondente) {
          this.$store.commit('addFiltro', filtroCorrespondente);
          this.$store.commit('setFiltrosAplicados', {
            ...this.$store.state.filtroAplicados,
            [key]: valor
          });
        }
      });
    },
    converterDataParaFormatoCorreto(data) {
      if (typeof data !== 'string') return data;
      
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
        return data;
      }
      
      if (/^\d{4}-\d{2}-\d{2}$/.test(data)) {
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
      }
      
      if (/^\d{2}-\d{2}-\d{4}$/.test(data)) {
        return data.replace(/-/g, '/');
      }
      
      return data;
    },
    removeFiltrosDeselecionados(filtrosUnicos) {
      const filtroURL = this.$capturaFiltrosDaURL();
      
      const filtrosValidos = new Set();
      filtrosUnicos.forEach(filtro => {
        filtrosValidos.add(filtro.filtro);
        
        if (filtro.component === 'date/DataEmissao') {
          filtrosValidos.add(`${filtro.filtro}_ini`);
          filtrosValidos.add(`${filtro.filtro}_fim`);
        }
      });

      const filtrosEspeciais = ['ordem'];
      filtrosEspeciais.forEach(filtro => filtrosValidos.add(filtro));
      
      const filtrosDeselecionados = filtroURL.arrayFiltro.filter(filtro => !filtrosValidos.has(filtro));

      filtrosDeselecionados.forEach(filtro => {
        this.$store.commit('removeFiltro', filtro);
        this.$removeFiltroDaURL(filtro, this.dataProperties.path);
      });
    }
  },
  mounted() {
    if (!this.dataProperties?.campos) {
      console.warn('dataProperties.campos não está definido');
      return;
    }

    const { arrayFiltro, filtros } = this.$capturaFiltrosDaURL();
    const matchingCampos = arrayFiltro
      .map(filtroKey => this.dataProperties.campos.find(campo => campo.filtro === filtroKey))
      .filter(Boolean);

    this.$store.commit('setFiltros', matchingCampos);
    this.$store.commit('setFiltrosAplicados', filtros);

    this.carregarFiltrosDoDb();
    this.buscaFiltros();
  }
}
</script>
